import"core-js/modules/es.array.filter.js";import"core-js/modules/es.object.to-string.js";import{isOptionAndFitsQuery}from"../isOptionAndFitsQuery";/**
 * Filters a set of options based on search string
 *
 * @param options
 * @param query
 * @returns {*}
 */export var filterOptionsForQuery=function(a,b){return a.filter(function(a){return isOptionAndFitsQuery(a,b)})};